import img from '../Images/image23.png';
import img2 from '../Images/image35.png';
import img3 from '../Images/image33.png';
import img4 from '../Images/Banner.png';
import img5 from '../Images/image92.png';
import img6 from '../Images/image92.png'
import img7 from '../Images/rasm.png';
import img8 from '../Images/image98.png';
import img9 from '../Images/image 28.png';
import imgCountry from '../Images/US@2x.png';
import imgCountry2 from '../Images/DE@2x.png';
import imgProduct from '../Images/image33.png'
import img2Product from '../Images/image23.png'
import img3Product from '../Images/image35.png'
import Rating from '../Components/Rating';

export const productsData = [{
        id: 1,
        isLike:false,
        isSelected:false,
        img: imgProduct,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Size: medium, Color: blue,  Material: Plastic
        Seller: Artel Market`
    }, {
        id: 2,
        isLike:false,
        isSelected:false,
        img: img2Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    }, {
        id: 3,
        isLike:false,
        isSelected:false,
        img: img3Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Size: medium, Color: blue,  Material: Plastic
        Seller: Artel Market`
    },
    {
        id: 4,
        isLike:false,
        isSelected:false,
        img: imgProduct,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    }, {
        id: 5,
        isLike:false,
        isSelected:false,
        img: img2Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    }, {
        id: 6,
        isLike:false,
        isSelected:false,
        img: img3Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    },
    {
        id: 7,
        isLike:false,
        isSelected:false,
        img: imgProduct,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit `
    }, {
        id: 8,
        isLike:false,
        isSelected:false,
        img: img2Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit `
    }, {
        id: 9,
        isLike:false,
        isSelected:false,
        img: img3Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    },
    {
        id: 10,
        isLike:false,
        isSelected:false,
        img: imgProduct,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    }, {
        id: 11,
        isLike:false,
        isSelected:false,
        img: img2Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    }, {
        id: 12,
        isLike:false,
        isSelected:false,
        img: img3Product,
        title: "Canon Cmera EOS 2000, Black 10x zoom",
        price: "$998.00",
        prevPrice: "$1128.00",
        orders: "174",
        freeShipping: true,
        description: `Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
    tempor incididunt ut labore et dolore magna aliqua`
    },
]
export const footerData = [{
        title: "About",
        lis: ["About Us", "Find store", "Categories", "Blogs"]
    },
    {
        title: "Partnership",
        lis: ["About Us", "Find store", "Categories", "Blogs"]
    },
    {
        title: "Information",
        lis: ["Help Center", "Money Refund", "Shipping", "Contact us"]
    },
    {
        title: "For users",
        lis: ["Login", "Register", "Settings", "My Orders"]
    }
]
export const dealsData = [{
        img: img8,
        name: "Smart watches",
        sale: "25"
    },
    {
        img: img,
        name: "Laptops",
        sale: "10"
    },
    {
        img: img5,
        name: "GoPro cameras",
        sale: "15"
    },
    {
        img: img2,
        name: "Headphones",
        sale: "20"
    },
    {
        img: img3,
        name: "Canon camreras",
        sale: "45"
    }
];
export const selectData = {
    Help: [{
            value: "",
            label: "Help"
        },
        {
            value: "Help1",
            label: "Help 1"
        },
        {
            value: "Help2",
            label: "Help 2"
        },
        {
            value: "Help3",
            label: "Help 3"
        }
    ],
    Language: [{
            value: "",
            label: "English, USD"
        },
        {
            value: "Language1",
            label: "Language 1"
        },
        {
            value: "Language2",
            label: "Language 2"
        },
        {
            value: "Language3",
            label: "Language 3"
        }
    ],
    Ship: [{
            value: "",
            label: "Ship to"
        },
        {
            value: "Ship1",
            label: "Ship 1"
        },
        {
            value: "Ship2",
            label: "Ship 2"
        },
        {
            value: "Ship3",
            label: "Ship 3"
        }
    ],
    Category: [{
            value: "",
            label: "category to"
        },
        {
            value: "category1",
            label: "category 1"
        },
        {
            value: "category2",
            label: "category 2"
        },
        {
            value: "category3",
            label: "category 3"
        }
    ],
    Qty: [{
            value: "Qty1",
            label: "Qty: 1"
        },
        {
            value: "Qty2",
            label: "Qty: 2"
        },
        {
            value: "Qty3",
            label: "Qty: 3"
        }
    ],
    Phone: [{
            value: "Phone1",
            label: "UZ +998"
        },
        {
            value: "Phone2",
            label: "UN +953"
        },
        {
            value: "Phone3",
            label: "PL +972"
        }
    ]
}
export const detailsData = {
    tableData: [{
            title: 'Model',
            decsription: '#8786867'
        },
        {
            title: 'Size',
            decsription: '34mm x 450mm x 19mm'
        },
        {
            title: 'Certificate',
            decsription: 'ISO-898921212'
        },
        {
            title: 'Style',
            decsription: 'Classic style'
        },
        {
            title: 'Memory',
            decsription: '36GB RAM'
        },
    ],
    feature: [
        "Some great feature name here",
        "Lorem ipsum dolor sit amet, consectetur ",
        "Duis aute irure dolor in reprehenderit",
        "Some great feature name here",
    ],
    navItem: [
        "Description",
        "Reviews",
        "Shipping",
        "About company",
    ]
}
export const recommendedData = [{
        img,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img2,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img3,
        price: '$9.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img4,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img5,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img6,
        price: '$5.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img7,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img8,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img9,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
    {
        img: img,
        price: '$10.5',
        description: "T-shirts with multiple colors, for men"
    },
]
export const CatigotyData = {
    li: [
        { id: 1, text: "Mobile accessory" },
        { id: 2, text: "Electronics" },
        { id: 3, text: "Smartphones" },
        { id: 4, text: "Modern tech" },
        { id: 5, text: "Electronics" },
        { id: 6, text: "Smartphones" },
        { id: 7, text: "Modern tech" },
    ],
    checkbox: [
        { id: 8, text: "Samsung" },
        { id: 9, text: "Apple" },
        { id: 10, text: "Smartphones" },
        { id: 11, text: "Huawei" },
        { id: 12, text: "Pocco" },
        { id: 13, text: "Lenovo" },
        { id: 14, text: "Modern tech" },
    ],
    checkbox2: [
        { id: 15, text: "Metallic" },
        { id: 16, text: "Plastic cover" },
        { id: 17, text: "Super power" },
        { id: 18, text: "Large Memory" },
        { id: 19, text: "Electronics" },
        { id: 20, text: "Smartphones" },
        { id: 21, text: "Modern tech" },
    ],
    radio: [
        { id: 21, text: "Samsung" },
        { id: 22, text: "Apple" },
        { id: 23, text: "Smartphones" },
        { id: 24, text: "Huawei" },
        { id: 25, text: "Pocco" },
        { id: 26, text: "Lenovo" },
        { id: 27, text: "Modern tech" },
    ],
    checkbox3: [
        { id: 28, text: <Rating num="4"/> },
        { id: 29, text: <Rating num="3"/> },
        { id: 30, text: <Rating num="2"/>},
        { id: 31, text: <Rating num="1"/> },
    ],
}
export const countryData = [{
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry: imgCountry2,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry: imgCountry2,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry: imgCountry2,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
    {
        imgCountry,
        title: "United States",
        description: "shopname.ae"
    },
]
export const cartData = [{
        img: img3,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img: img5,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img: img2,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img: img4,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
    {
        img,
        title: "Apple Watch Series Space Gray",
        details: 'Apple Watch Series Space GrayApple Watch Series Space Gray',
        price: "$7.00 - $99.50"
    },
]
export const HomeData = {
    mydata: {
        imgcard: {
            img: img5,
            h6: "Home and outdoor",
            button: "Source now"
        },
        items: [{
                img: img2,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img3,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img4,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img5,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img6,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img7,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img8,
                title: "Soft chairs",
                description: "From USD 19"
            },
            {
                img: img9,
                title: "Soft chairs",
                description: "From USD 19"
            },

        ]
    },
    mydata2: {
        imgcard: {
            img: img8,
            h6: "Consumer electronics and gadgets",
            button: "Source now"
        },
        items: [{
                img: img9,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img4,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img6,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img4,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img7,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img8,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img9,
                title: "Smart watches",
                description: "From USD 19"
            },
            {
                img: img3,
                title: "Smart watches",
                description: "From USD 19"
            },

        ]
    }
}